// import React, { useEffect, useState } from 'react';
// import classes from './CanteenPay.module.scss';
// import { useDispatch, useSelector } from 'react-redux';
// import toast from 'react-hot-toast';
// import useSound from 'use-sound';
// import successSound from './../../../utilities/success.mp3';
// import { canteenMenu } from '../../../API/API';
// import { closePaymenu ,paymenIsSuccessfull} from './../../../Redux/action/interactions';
// import { canteenPay, walletHistory } from './../../../API/API';
// import debounce from 'lodash';
// import { useNavigate } from "react-router-dom";

// const PayMenu = () => {
//     const data = JSON.parse(localStorage.getItem('data'));
//     const userID = localStorage.getItem('userID');

//     const [amount, setAmount] = useState(null);
//     const [message, setMessage] = useState('');
        
//     const paySuccess = useSelector (state => state.interactions.paymentSuccess);
//     const dispatch = useDispatch();
//     const [play] = useSound(successSound);

//     const amountChange = (event) => {
//         setAmount(event.target.value);
//     }
//     const messageChange = (event) => {
//         setMessage(event.target.value);
//     }
//     //To handle disabling enabling button on Pay
//     const [isButtonDisabled, setButtonDisabled] = useState(false);
 
//     const disableButton = () => {
//         setButtonDisabled(true);
//     };
 
//     const enableButton = () => {
//         setButtonDisabled(false);
//     };

//     //Get Amount from LocalStorage it will be there if the selection was made from Canteen Action
//     const [order, setOrder] = useState(JSON.parse(localStorage.getItem('order')));
//     const navigate = useNavigate(); //For navigating to payment history page
//     useEffect(() => {
//         // console.log(JSON.parse(localStorage.getItem('order')));
//         const menuItems = JSON.parse(localStorage.getItem('order'));
//         if(menuItems) {
//             const orderSummary = menuItems.map(items => items.name + '*' + items.quantity + '=' + items.amt).join(', ');
//             const orderAmt = menuItems.reduce((sum, item) => sum + item.amt ,0);
//             setAmount(orderAmt);
//             setMessage(orderSummary.toString());
//             console.log(orderAmt, orderSummary);
//         }
//         //Enable the Pay button on Opening Menu afresh!
//         enableButton();
//       }, []);
//           //Show Wallet Balance
//     const [transHistory, setHistory] = useState([]);
//     useEffect(() => {

//         if (userID !== null & data !== null) {
//             walletHistory(userID, data.empid, data.token)
//                 .then(response => {
//                     setHistory(response.data)
//                 })
//                 .catch(() => {
//                     setHistory([])
//                     toast("Unable to Fetch Wallet History", {
//                         icon: '❗',
//                         duration: 4500
//                     });
//                 })
//         }
//     }, [userID,order])
//     //End Get Amount of Order and wallet Balance
//     const handlePay = (event) => {
//         event.preventDefault();
//         //Disable the Pay button on Opening Menu afresh!
//         disableButton();
//         debounce(payAmount(),100);
//     };

//     const payAmount = () =>{
//         if(data !==null && userID !==null){
//             let amt = parseInt(amount)
//             if(amt===0){
//                 toast.error("Amount is 0")
//                 return;
//             }
//             if(amt.toString().trim().length === 0){
//                 toast.error("Please Enter Amount")
//                 return;
//             }
//             if(amt<0){
//                 toast.error("Amount is Cannot Be Negative")
//                 return;
//             }
                
//                 canteenPay(userID,data.empid,data.token,amt,message.toString())
//                 .then((response)=>{
                   
//                     if(response.data.message === "INVALIDDRAMOUNT"){
//                         dispatch(closePaymenu(false))
//                         toast.error("Insufficient Balanace")
//                     }else if (response.data.message === "success" && response.data.response ==="OK"){
//                         dispatch(closePaymenu(false));
//                         dispatch(paymenIsSuccessfull());
//                         play()
//                         toast.success(`Paid Successfully`,{
//                             duration:4000
//                         })
//                     }
//                     if (order) navigate("/dashboard/canteenpay");
//                 })
//                 .catch((error) =>{
//                     toast.error("Canteen Payment Not Working Try After Sometime",{
//                         duration:4000
//                     });
//                     dispatch(closePaymenu(false))
//                 })         
//         }
//     }

// //Functions to add or Remove Items
//   const [menuItems, setMenuItems] = useState([]);
//   const handleAddItem = (itemName) => {
//     const existingItem = menuItems.find((item) => item.name === itemName);
//     if (existingItem) {
//       setMenuItems(
//         menuItems.map((item) =>
//           item.name === itemName ? { ...item, quantity: item.quantity + 1, amt: item.amt + parseFloat(itemName.split('-')[1]) } : item
//         )
//       );
//     } else {
//       if (menuItems.length === 0 ) {
//         setMenuItems([{ name: itemName, quantity: 1, amt: parseFloat(itemName.split('-')[1]) }]);
//         // handleAddItem(itemName);
//       }
//       setMenuItems([...menuItems, { name: itemName, quantity: 1, amt: parseFloat(itemName.split('-')[1]) }]);
//     }
//   };
//   const handleRemoveItem = (itemName) => {
//     setMenuItems((prevMenuItems) => {
//       const existingItemIndex = prevMenuItems.findIndex((item) => item.name === itemName);
  
//       if (existingItemIndex !== -1) {
//         const updatedItems = [...prevMenuItems];
  
//         if (updatedItems[existingItemIndex].quantity > 1) {
//           // Decrement quantity if greater than 1
//           updatedItems[existingItemIndex].quantity -= 1;
//           updatedItems[existingItemIndex].amt -= parseFloat(itemName.split('-')[1]);
//           return updatedItems;
//         } else {
//           // Remove item if quantity is 1
//           updatedItems.splice(existingItemIndex, 1);
//           return updatedItems;
//         }
//       } else {
//         // Item not found, no change needed
//         return prevMenuItems;
//       }
//     });
//   };

//   const [menu, setMenu] = useState([{
//     Monday: [],
//     Tuesday: [],
//     Wednesday: [],
//     Thursday: [],
//     Friday: [],
//     saturday: [],
//   }]);

//   useEffect(() => {
//     if (data !== null && userID !== null) {
//       canteenMenu(userID, data.empid, data.token, data.company)
//         .then(response => {
//           const Monday = response.data.filter((item)=>{
//             return item.fday === "Monday"
//         })
//         const Tuesday = response.data.filter((item)=>{
//             return item.fday === "Tuesday"
//         })
//         const Wednesday = response.data.filter((item)=>{
//             return item.fday === "Wednesday"
//         })
//         const Thursday = response.data.filter((item)=>{
//             return item.fday === "Thursday"
//         })
//         const Friday = response.data.filter((item)=>{
//             return item.fday === "Friday"
//         })
//         const Saturday = response.data.filter((item)=>{
//             return item.fday === "Saturday"
//         })
//         setMenu({
//             Monday: Monday[0],
//             Tuesday: Tuesday[0],
//             Wednesday: Wednesday[0],
//             Thursday: Thursday[0],
//             Friday: Friday[0],
//             Saturday: Saturday.length === 0 ? {fday:"Saturday",bfast: "Weekend Off", lunch: "Weekend Off", htea: "Weekend Off", others: "Weekend Off"} : Saturday[0]
//         })
//         })
//     }    
//     return () => {
//     }
//   }, [userID])


//   const [todayMenu, setTodayMenu] = useState([])
//   const weekday = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
//   let d = new Date();
//   let day = weekday[d.getDay()];

//   useEffect(() => {
//     localStorage.setItem('order', JSON.stringify(menuItems));
//   }, [menuItems]);

//     return (
//         <div className={classes.PayMenuContainer}>
//             {/* <h2>Other Snacks</h2>
//             <tr>
//               <td valign='top'><h3>Other Snacks:</h3></td>
//                 </tr><tr>
//                 <td valign='top' style={{ display: "flex" , flexDirection:'column',gap:"0px"}} >
//                 <>{todayMenu.others ? (todayMenu.others.split('/').map(((item) => {
//                     return <p className={classes.bottomBorder} key={item}>{item} 
//                     <span><button className={classes.btnQty} onClick={() => handleRemoveItem(item)}>-</button>
//                     <button className={classes.btnQty} onClick={() => handleAddItem(item)}>+</button>
//                     </span><br></br>&nbsp;<br></br><br></br><br></br></p>
//                 }))) : " "}</></td>
//             </tr> */}
//             <h2>Wallet Balance: ₹ {transHistory.length > 0 ? transHistory[0].total : " "}</h2>
//             <input type="number" readOnly={(order?"readonly":"")} placeholder={"₹"} onChange={amountChange} value={parseInt(amount)} min={0} />
//             <input type="text" readOnly={(order?"readonly":"")} style={order?{"font-size":"15px"}:{}} placeholder='Add Message' onChange={messageChange} value={message}/>
//             <div className={classes.ButtonDiv}>
//                 <button disabled={isButtonDisabled} onClick={handlePay}>PAY</button>
//                 <button onClick={() => {dispatch(closePaymenu(false))}}>CANCEL</button>
//             </div>
//         </div>
//     )
// }
// export default PayMenu










// BIRTHDAY CELEBRATION 

// import React, { useEffect, useState, useCallback } from 'react';
// import classes from './CanteenPay.module.scss';
// import { useDispatch, useSelector } from 'react-redux';
// import toast from 'react-hot-toast';
// import useSound from 'use-sound';
// import successSound from './../../../utilities/success.mp3';
// import { closePaymenu, paymenIsSuccessfull } from './../../../Redux/action/interactions';
// import { canteenPay, walletHistory } from './../../../API/API';
// import { debounce } from 'lodash';
// import { useNavigate } from "react-router-dom";

// const PayMenu = () => {
//     const data = JSON.parse(localStorage.getItem('data')) || {};
//     const userID = localStorage.getItem('userID');
//     const [amount, setAmount] = useState('');
//     const [message, setMessage] = useState();
//     const paySuccess = useSelector(state => state.interactions.paymentSuccess);
//     const dispatch = useDispatch();
//     const [play] = useSound(successSound);
//     const [isButtonDisabled, setButtonDisabled] = useState(false);
//     const [order, setOrder] = useState(JSON.parse(localStorage.getItem('order')) || []);
//     const navigate = useNavigate();
//     const [transHistory, setHistory] = useState([]);

//     const amountChange = (event) => {
//         setAmount(event.target.value);
//     }

//     const disableButton = () => {
//         setButtonDisabled(true);
//     };

//     const enableButton = () => {
//         setButtonDisabled(false);
//     };

//     const messageChange = (event) => {
//          setMessage(event.target.value);
//      };

//     useEffect(() => {
//         const menuItems = JSON.parse(localStorage.getItem('order'));
//         if (menuItems) {
//             const orderSummary = menuItems.map(item => `${item.name}*${item.quantity}=${item.amt}`).join(', ');
//             const orderAmt = menuItems.reduce((sum, item) => sum + item.amt, 0);
//             setAmount(orderAmt < 200 ? 200 : orderAmt);
//         }
//         enableButton();
//     }, []);

//     useEffect(() => {
//         if (userID && data.empid && data.token) {
//             walletHistory(userID, data.empid, data.token)
//                 .then(response => {
//                     setHistory(response.data)
//                 })
//                 .catch(() => {
//                     setHistory([]);
//                     toast("Unable to Fetch Wallet History", {
//                         icon: '❗',
//                         duration: 4500
//                     });
//                 });
//         }
//     }, [userID, order]);

//     const payAmount = useCallback(debounce(() => {
//         if (data && userID) {
//             const amt = parseInt(amount);
//             if (amt < 200) {
//                 toast.error("The transaction amount must be greater than 200 for Miscelleneous Items!");
//                 enableButton();
//                 return;
//             }

//             canteenPay(userID, data.empid, data.token, amt, message)
//                 .then(response => {
//                     if (response.data.message === "INVALIDDRAMOUNT") {
//                         dispatch(closePaymenu(false));
//                         toast.error("Insufficient Balance, Please Recharge Your Wallet");
//                     } else if (response.data.message === "success" && response.data.response === "OK") {
//                         dispatch(closePaymenu(false));
//                         dispatch(paymenIsSuccessfull());
//                         play();
//                         toast.success("Paid Successfully", { duration: 4000 });
//                     }
//                     if (order) navigate("/dashboard/canteenpay");
//                 })
//                 .catch(() => {
//                     toast.error("Canteen Payment Not Working. Try Again Later.", { duration: 4000 });
//                     dispatch(closePaymenu(false));
//                 });
//         }
//     }, 100), [amount, message, userID, data, dispatch, play, order, navigate]);

//     const handlePay = (event) => {
//         event.preventDefault();
//         disableButton();
//         payAmount();
//     };

//     return (
//         <div className={classes.PayMenuContainer}>
//             <h1>Pay Amount</h1>
//             <h2>Wallet Balance: ₹ {transHistory.length > 0 ? transHistory[0].total : " "}</h2>
//             <input 
//                 type="number" 
//                 placeholder="₹" 
//                 onChange={amountChange} 
//                 value={amount} 
//                 min={200} 
//             />

//             <input className="Message"
//             type="text"  
//             placeholder='Add Message' 
//             onChange={messageChange} 
//             value={message}
//             />
      
//             <div className={classes.ButtonDiv}>
//                 <button disabled={isButtonDisabled} onClick={handlePay}>PAY</button>
//                 <button onClick={() => { dispatch(closePaymenu(false)) }}>CANCEL</button>
//             </div>
//         </div>
//     );
// }

// export default PayMenu;














import React, { useEffect, useState } from 'react';
import classes from './CanteenPay.module.scss';
import { useDispatch, useSelector } from 'react-redux';
import toast from 'react-hot-toast';
import useSound from 'use-sound';
import successSound from './../../../utilities/success.mp3';
import { canteenMenu } from '../../../API/API';
import { closePaymenu ,paymenIsSuccessfull} from './../../../Redux/action/interactions';
import { canteenPay, walletHistory } from './../../../API/API';
import debounce from 'lodash';
import { useNavigate } from "react-router-dom";

const PayMenu = () => {
    const data = JSON.parse(localStorage.getItem('data'));
    const userID = localStorage.getItem('userID');
    const [amount, setAmount] = useState(null);
    const [message, setMessage] = useState('');
        
    const paySuccess = useSelector(state => state.interactions.paymentSuccess);
    const dispatch = useDispatch();
    
    const [play] = useSound(successSound);

    const amountChange = (event) => {
        setAmount(event.target.value);
    }
    const messageChange = (event) => {
        setMessage(event.target.value);
    }

    // To handle disabling/enabling button on Pay
    const [isButtonDisabled, setButtonDisabled] = useState(false);

    const disableButton = () => {
        setButtonDisabled(true);
    };
 
    const enableButton = () => {
        setButtonDisabled(false);
    };

    // Get Amount from LocalStorage it will be there if the selection was made from Canteen Action
    const [order, setOrder] = useState(JSON.parse(localStorage.getItem('order')));
    const navigate = useNavigate(); // For navigating to payment history page
    
    useEffect(() => {
        const menuItems = JSON.parse(localStorage.getItem('order'));
        if (menuItems) {
            const orderSummary = menuItems.map(items => items.name + '*' + items.quantity + '=' + items.amt).join(', ');
            const orderAmt = menuItems.reduce((sum, item) => sum + item.amt, 0);           
            setAmount(orderAmt);
            setMessage(orderSummary.toString());    
        }
        // Enable the Pay button on Opening Menu afresh!
        enableButton();
    }, []);   
    // Show Wallet Balance
    const [transHistory, setHistory] = useState([]);
    
    useEffect(() => {
        if (userID !== null && data !== null) {
            walletHistory(userID, data.empid, data.token)
                .then(response => {
                    setHistory(response.data)
                })
                .catch(() => {
                    setHistory([]);
                    toast("Unable to Fetch Wallet History", {
                        icon: '❗',
                        duration: 4500
                    });
                });
        }
    }, [userID, order]);
   

    // End Get Amount of Order and wallet Balance
    const handlePay = (event) => {
        event.preventDefault();
        disableButton();
        debounce(payAmount(), 100);
    };

    const handleMinPay = (event) => {
        event.preventDefault();
        disableButton();
        debounce(payMinAmount(), 100);
    };

    const payAmount = () => {
        if (data !== null && userID !== null) {
            let amt = parseInt(amount);
            if (amt === 0) {
                toast.error("Amount is 0");
                return;
            }
            if (amt.toString().trim().length === 0) {
                toast.error("Please Enter Amount");
                return;
            }
            if (amt < 0) {
                toast.error("Amount Cannot Be Negative");
                return;
            }

            canteenPay(userID, data.empid, data.token, amt, message.toString())
                .then((response) => {
                    if (response.data.message === "INVALIDDRAMOUNT") {
                        dispatch(closePaymenu(false));
                        toast.error("Insufficient Balance");
                    } else if (response.data.message === "success" && response.data.response === "OK") {
                        dispatch(closePaymenu(false));
                        dispatch(paymenIsSuccessfull());
                        play();
                        toast.success(`Paid Successfully`, {
                            duration: 4000
                        });
                    }
                    if (order) navigate("/dashboard/canteenpay");
                })
                .catch((error) => {
                    toast.error("Canteen Payment Not Working Try After Sometime", {
                        duration: 4000
                    });
                    dispatch(closePaymenu(false));
                });
        }
    };

    const payMinAmount = () => {
        if (data !== null && userID !== null) {
            let amt = parseInt(amount);
            if (amt < 200) {
                toast.error("Amount must be at least 200");
                enableButton();
                return;
            }
            payAmount();
        }
    };

    const [menuItems, setMenuItems] = useState([]);
    const handleAddItem = (itemName) => {
        const existingItem = menuItems.find((item) => item.name === itemName);
        if (existingItem) {
            setMenuItems(
                menuItems.map((item) =>
                    item.name === itemName ? { ...item, quantity: item.quantity + 1, amt: item.amt + parseFloat(itemName.split('-')[1]) } : item
                )
            );
        } else {
            setMenuItems([...menuItems, { name: itemName, quantity: 1, amt: parseFloat(itemName.split('-')[1]) }]);
        }
    };
    

    const handleRemoveItem = (itemName) => {
        setMenuItems((prevMenuItems) => {
            const existingItemIndex = prevMenuItems.findIndex((item) => item.name === itemName);

            if (existingItemIndex !== -1) {
                const updatedItems = [...prevMenuItems];

                if (updatedItems[existingItemIndex].quantity > 1) {
                    updatedItems[existingItemIndex].quantity -= 1;
                    updatedItems[existingItemIndex].amt -= parseFloat(itemName.split('-')[1]);
                    return updatedItems;
                } else {
                    updatedItems.splice(existingItemIndex, 1);
                    return updatedItems;
                }
            } else {
                return prevMenuItems;
            }
        });
    };

    const [menu, setMenu] = useState([{
        Monday: [],
        Tuesday: [],
        Wednesday: [],
        Thursday: [],
        Friday: [],
        Saturday: [],
    }]);

    useEffect(() => {
        if (data !== null && userID !== null) {
            canteenMenu(userID, data.empid, data.token, data.company)
                .then(response => {
                    const Monday = response.data.filter((item) => item.fday === "Monday");
                    const Tuesday = response.data.filter((item) => item.fday === "Tuesday");
                    const Wednesday = response.data.filter((item) => item.fday === "Wednesday");
                    const Thursday = response.data.filter((item) => item.fday === "Thursday");
                    const Friday = response.data.filter((item) => item.fday === "Friday");
                    const Saturday = response.data.filter((item) => item.fday === "Saturday");
                    setMenu({
                        Monday: Monday[0],
                        Tuesday: Tuesday[0],
                        Wednesday: Wednesday[0],
                        Thursday: Thursday[0],
                        Friday: Friday[0],
                        Saturday: Saturday.length === 0 ? { fday: "Saturday", bfast: "Weekend Off", lunch: "Weekend Off", htea: "Weekend Off", others: "Weekend Off" } : Saturday[0]
                    });
                });
        }
    }, [userID]);

    const [todayMenu, setTodayMenu] = useState([]);
    const weekday = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    let d = new Date();
    let day = weekday[d.getDay()];

    useEffect(() => {
        localStorage.setItem('order', JSON.stringify(menuItems));
    }, [menuItems]);

    return (
        <div className={classes.PayMenuContainer}>
            <h2>Wallet Balance: ₹ {transHistory.length > 0 ? transHistory[0].total : " "}</h2>
            <input type="number" readOnly={order ? "readonly" : ""} placeholder={"₹"} onChange={amountChange} value={parseInt(amount)} min={0} />
            <input type="text" readOnly={order ? "readonly" : ""} style={order ? { "font-size": "15px" } : {}} placeholder='Add Message' onChange={messageChange} value={message} />
            <div className={classes.ButtonDiv}>
                <button disabled={isButtonDisabled} onClick={handlePay}>PAY</button>
                <button onClick={() => { dispatch(closePaymenu(false)) }}>CANCEL</button>
            </div>
        </div>
    );
};

export default PayMenu;
